// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner-module--spinnerContainer--3mRZ3","spinner":"Spinner-module--spinner---6thG","innerSpinner":"Spinner-module--innerSpinner--1nSnh"};